const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL;

const authHeaders = async (getToken) => {
  const token = await getToken();

  const headers = {
    "Content-Type": "application/json",
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  return headers;
};

const parseJson = async (res) => {
  try {
    return await res.json();
  } catch (_) {
    return null;
  }
};

export const createRazorpayOrder = async (getToken) => {
  const res = await fetch(`${API_BASE_URL}/api/payment/create-order`, {
    method: "POST",
    headers: await authHeaders(getToken),
  });

  const data = await parseJson(res);

  if (!res.ok) {
    throw new Error(data?.error || "Unable to create payment order");
  }

  return data;
};

export const verifyRazorpayPayment = async (getToken, payment) => {
  const payload = {
    razorpay_payment_id: payment?.razorpay_payment_id,
    razorpay_order_id: payment?.razorpay_order_id,
    razorpay_signature: payment?.razorpay_signature,
  };

  const res = await fetch(`${API_BASE_URL}/api/payment/verify-payment`, {
    method: "POST",
    headers: await authHeaders(getToken),
    body: JSON.stringify(payload),
  });

  const data = await parseJson(res);

  if (!res.ok) {
    throw new Error(data?.error || "Unable to verify payment");
  }

  return data;
};
